// import React, { useState, useEffect, createContext, useContext } from "react";
// import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";

// // Components (Keep all your existing imports)
// import Login from "./components/Login";
// import Dashboard from "./components/Dashboard";
// import SupervisorDashboard from "./components/SupervisorDashboard";
// import Profile from "./components/Profile";
// import Settings from './components/Settings';
// import SuperAdminDashboard from "./components/SuperAdminDashboard";
// import SupervisorAppraisalForm from "./components/SupervisorAppraisalForm";
// import SuperAdminStaffGoals from "./components/SuperAdminStaffGoals";
// import ManageTeam from "./components/ManageTeam";
// import SuperAdminManageTeam from "./components/SuperAdminManageTeam";
// import PerformanceOnGoals from "./components/PerformanceOnGoals";
// import Compliance from "./components/Compliance";
// import Summary from "./components/Summary";
// import Records from "./components/Records";
// import WorkEthicLeadership from "./components/WorkEthicLeadership";
// import AdminDashboard from "./components/AdminDashboard";
// import AdminAppraisalForm from "./components/AdminAppraisalForm";
// import ComplianceSettings from "./components/ComplianceSettings";
// import SupervisorStaffScore from "./components/SupervisorStaffScore";
// // 🔥 1. Create the Theme Context 🔥
// export const ThemeContext = createContext();

// // 🔥 2. Create a Custom Hook for easy access 🔥
// export const useTheme = () => useContext(ThemeContext);

// function App() {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [collapsed, setCollapsed] = useState(false);

//   // 🔥 3. Manage Dark Mode State globally 🔥
//   const [isDarkMode, setIsDarkMode] = useState(() => {
//     return localStorage.getItem("appTheme") === "dark";
//   });

//   // Toggle function passed down via context
//   const toggleTheme = () => {
//     setIsDarkMode((prev) => {
//       const newTheme = !prev;
//       localStorage.setItem("appTheme", newTheme ? "dark" : "light");
//       return newTheme;
//     });
//   };

//   const clearAuthStorage = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("user");
//   };

//   useEffect(() => {
//     const storedUser = localStorage.getItem("user");
//     const token = localStorage.getItem("token");

//     if (!storedUser || !token) {
//       clearAuthStorage();
//       setUser(null);
//       setLoading(false);
//       return;
//     }

//     try {
//       setUser(JSON.parse(storedUser));
//     } catch (error) {
//       clearAuthStorage();
//       setUser(null);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   const handleSetUser = (userData) => {
//     setUser(userData);
//     if (userData) {
//       localStorage.setItem("user", JSON.stringify(userData));
//     } else {
//       clearAuthStorage();
//     }
//   };

//   const isAuthenticated = () => !!user && !!localStorage.getItem("token");

//   const isSupervisor = () => user?.role === "supervisor";
//   const isAdmin = () => user?.role === "admin";
//   const isSuperAdmin = () => user?.role === "super_admin";

//   if (loading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center vh-100">
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   return (
//     // 🔥 4. Wrap everything in the ThemeContext.Provider 🔥
//     <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
//       <BrowserRouter>
//         {/* We can optionally add a global class to the body here if needed */}
//         <div className={`App ${isDarkMode ? 'dark-theme' : 'light-theme'}`}>
//           <Routes>
//             {/* LOGIN ROUTE */}
//             <Route
//               path="/"
//               element={
//                 !isAuthenticated() ? (
//                   <Login setUser={handleSetUser} />
//                 ) : (
//                   <Navigate
//                     to={
//                       isSuperAdmin() ? "/super-admin/dashboard"
//                         : isAdmin() ? "/admin/dashboard"
//                         : isSupervisor() ? "/supervisor/dashboard"
//                         : "/dashboard"
//                     }
//                   />
//                 )
//               }
//             />

//             {/* SETTINGS */}
//             <Route
//               path="/settings"
//               element={
//                 isAuthenticated() ? (
//                   <Settings
//         user={user}
//         setUser={setUser} // 🔥 ADD THIS LINE
//         collapsed={collapsed}
//         setCollapsed={setCollapsed}
//       />
//                 ) : (
//                   <Navigate to="/" />
//                 )
//               }
//             />

//             {/* PROFILE */}
//             <Route
//               path="/profile"
//               element={
//                 isAuthenticated() ? (
//                   <Profile
//                     user={user}
//                     setUser={setUser}
//                     collapsed={collapsed}
//                     setCollapsed={setCollapsed}
//                   />
//                 ) : (
//                   <Navigate to="/" />
//                 )
//               }
//             />

//             {/* ... Keep the rest of your exact same routes here unchanged ... */}
//             <Route path="/dashboard" element={isAuthenticated() ? <Dashboard user={user} collapsed={collapsed} setCollapsed={setCollapsed}/> : <Navigate to="/" />} />
//             <Route path="/performance" element={isAuthenticated() ? <PerformanceOnGoals user={user} collapsed={collapsed} setCollapsed={setCollapsed}/> : <Navigate to="/" />} />
//             <Route path="/compliance" element={isAuthenticated() ? <Compliance user={user} collapsed={collapsed} setCollapsed={setCollapsed}/> : <Navigate to="/" />} />
//             <Route path="/summary" element={isAuthenticated() ? <Summary user={user} collapsed={collapsed} setCollapsed={setCollapsed}/> : <Navigate to="/" />} />
//             <Route path="/work-ethic" element={isAuthenticated() ? <WorkEthicLeadership user={user} collapsed={collapsed} setCollapsed={setCollapsed}/> : <Navigate to="/" />} />
//             <Route path="/records" element={isAuthenticated() ? <Records user={user} collapsed={collapsed} setCollapsed={setCollapsed}/> : <Navigate to="/" />} />
//             <Route path="/supervisor/dashboard" element={isAuthenticated() && isSupervisor() ? <SupervisorDashboard user={user} collapsed={collapsed} setCollapsed={setCollapsed}/> : <Navigate to="/" />} />
//             <Route path="/supervisor/appraisal/:appraisalId" element={isAuthenticated() && isSupervisor() ? <SupervisorAppraisalForm user={user} collapsed={collapsed} setCollapsed={setCollapsed}/> : <Navigate to="/" />} />
//             <Route path="/supervisor/team" element={isAuthenticated() && (isSupervisor() || isSuperAdmin()) ? <ManageTeam user={user} /> : <Navigate to="/" />} />
//             <Route path="/supervisor/goals/:userId" element={isAuthenticated() && (isSupervisor() || isSuperAdmin()) ? <SupervisorStaffScore user={user} /> : <Navigate to="/" />} />
//             <Route path="/admin/dashboard" element={isAuthenticated() && isAdmin() ? <AdminDashboard user={user} collapsed={collapsed} setCollapsed={setCollapsed}/> : <Navigate to="/" />} />
//             <Route path="/admin/goals/:userId" element={isAuthenticated() && isAdmin() ? <AdminAppraisalForm user={user} collapsed={collapsed} setCollapsed={setCollapsed}/> : <Navigate to="/" />} />

//             {/* //`/admin/goals/${staff._id} */}
//             {/* <Route path="/admin/appraisal/:appraisalId" element={isAuthenticated() && isAdmin() ? <AdminAppraisalForm user={user} collapsed={collapsed} setCollapsed={setCollapsed}/> : <Navigate to="/" />} /> */}
//             <Route path="/super-admin/dashboard" element={isAuthenticated() && isSuperAdmin() ? <SuperAdminDashboard user={user} collapsed={collapsed} setCollapsed={setCollapsed}/> : <Navigate to="/" />} />
//             <Route path="/super-admin/appraisal/:appraisalId" element={isAuthenticated() && isSuperAdmin() ? <SupervisorAppraisalForm user={user} collapsed={collapsed} setCollapsed={setCollapsed}/> : <Navigate to="/" />} />
//             <Route path="/super-admin/goals/:userId" element={isAuthenticated() && isSuperAdmin() ? <SuperAdminStaffGoals user={user} collapsed={collapsed} setCollapsed={setCollapsed}/> : <Navigate to="/" />} />
//             <Route path="/super-admin/team" element={isAuthenticated() && isSuperAdmin() ? <SuperAdminManageTeam user={user} /> : <Navigate to="/" />} />
//             <Route path="/super-admin/complianceSettings" element={isAuthenticated() && isSuperAdmin() ? <ComplianceSettings user={user} /> : <Navigate to="/" />} />

//             {/* CATCH-ALL ROUTE */}
//             <Route
//               path="*"
//               element={
//                 <Navigate
//                   to={
//                     isAuthenticated()
//                       ? isSuperAdmin() ? "/super-admin/dashboard"
//                         : isAdmin() ? "/admin/dashboard"
//                         : isSupervisor() ? "/supervisor/dashboard"
//                         : "/dashboard"
//                       : "/"
//                   }
//                 />
//               }
//             />
//           </Routes>
//         </div>
//       </BrowserRouter>
//     </ThemeContext.Provider>
//   );
// }

// export default App;














import React, { useState, useEffect, createContext, useContext } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

// Components
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import SupervisorDashboard from "./components/SupervisorDashboard";
import Profile from "./components/Profile";
import Settings from './components/Settings';
import SuperAdminDashboard from "./components/SuperAdminDashboard";
import SupervisorAppraisalForm from "./components/SupervisorAppraisalForm";
import SuperAdminStaffGoals from "./components/SuperAdminStaffGoals";
import ManageTeam from "./components/ManageTeam";
import SuperAdminManageTeam from "./components/SuperAdminManageTeam";
import PerformanceOnGoals from "./components/PerformanceOnGoals";
import Compliance from "./components/Compliance";
import Summary from "./components/Summary";
import Records from "./components/Records";
import WorkEthicLeadership from "./components/WorkEthicLeadership";
import AdminDashboard from "./components/AdminDashboard";
import AdminAppraisalForm from "./components/AdminAppraisalForm";
import ComplianceSettings from "./components/ComplianceSettings";
import SupervisorStaffScore from "./components/SupervisorStaffScore";
import VideoPlayer from "./components/VideoPlayer";
// Add these if they don't exist yet
// import About from "./components/About";
// import Resources from "./components/Resources";
// import Evangelist from "./components/Evangelist";

export const ThemeContext = createContext();
export const useTheme = () => useContext(ThemeContext);

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(() => 
    localStorage.getItem("appTheme") === "dark"
  );

  const toggleTheme = () => {
    setIsDarkMode((prev) => {
      const newTheme = !prev;
      localStorage.setItem("appTheme", newTheme ? "dark" : "light");
      return newTheme;
    });
  };

  const clearAuthStorage = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const token = localStorage.getItem("token");

    if (!storedUser || !token) {
      clearAuthStorage();
      setUser(null);
    } else {
      try {
        setUser(JSON.parse(storedUser));
      } catch (error) {
        clearAuthStorage();
        setUser(null);
      }
    }
    setLoading(false);
  }, []);

  const handleSetUser = (userData) => {
    setUser(userData);
    if (userData) {
      localStorage.setItem("user", JSON.stringify(userData));
    } else {
      clearAuthStorage();
    }
  };

  const isAuthenticated = () => !!user && !!localStorage.getItem("token");
  const isSupervisor = () => user?.role === "supervisor";
  const isAdmin = () => user?.role === "admin";
  const isSuperAdmin = () => user?.role === "super_admin";

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      <BrowserRouter>
        <div className={`App ${isDarkMode ? 'dark-theme' : 'light-theme'}`}>
          <Routes>
            {/* Public Login */}
 {/* Public Login */}
<Route
  path="/"
  element={
    !isAuthenticated() ? (
      <Login setUser={handleSetUser} />
    ) : (
      <Navigate
        to={
          isSuperAdmin() ? "/super-admin/dashboard"
          : isAdmin() ? "/admin/dashboard"
          : isSupervisor() ? "/supervisor/dashboard"
          : "/dashboard"
        }
        replace
      />
    )
  }
/>

            {/* Protected Routes */}
<Route 
  path="/live" 
  element={
    isAuthenticated() ? (
      <PerformanceOnGoals 
        user={user} 
        collapsed={collapsed} 
        setCollapsed={setCollapsed} 
      />
    ) : (
      <Navigate to="/" replace />
    )
  } 
/>
            <Route path="/dashboard" element={isAuthenticated() ? <Dashboard user={user} collapsed={collapsed} setCollapsed={setCollapsed} /> : <Navigate to="/" />} />
            <Route path="/message" element={isAuthenticated() ? <Compliance user={user} collapsed={collapsed} setCollapsed={setCollapsed} /> : <Navigate to="/" />} />
            <Route path="/discipleship" element={isAuthenticated() ? <Summary user={user} collapsed={collapsed} setCollapsed={setCollapsed} /> : <Navigate to="/" />} />
            <Route path="/training" element={isAuthenticated() ? <WorkEthicLeadership user={user} collapsed={collapsed} setCollapsed={setCollapsed} /> : <Navigate to="/" />} />
            <Route path="/records" element={isAuthenticated() ? <Records user={user} collapsed={collapsed} setCollapsed={setCollapsed} /> : <Navigate to="/" />} />


            <Route path="/settings" element={isAuthenticated() ? <Settings user={user} setUser={setUser} collapsed={collapsed} setCollapsed={setCollapsed} /> : <Navigate to="/" />} />
            <Route path="/profile" element={isAuthenticated() ? <Profile user={user} setUser={setUser} collapsed={collapsed} setCollapsed={setCollapsed} /> : <Navigate to="/" />} />

            {/* <Route
              path="*"
              element={
                <Navigate
                  to={
                    isAuthenticated()
                      ? isSuperAdmin() ? "/super-admin/dashboard"
                        : isAdmin() ? "/admin/dashboard"
                        : isSupervisor() ? "/supervisor/dashboard"
                        : "/dashboard"
                      : "/"
                  }
                />
              }
            /> */}
          </Routes>
        </div>
      </BrowserRouter>
    </ThemeContext.Provider>
  );
}

export default App;